export default __webpack_public_path__ + "static/media/android-app-icons-mono.51fed402.webp";